import axios from "axios";
// Create an instance of axios
const api = axios.create({
    baseURL: process.env.REACT_APP_JERSEYDIRECTORY_API_URL,
});

// Add a request interceptor for the token to allow access to the authorize api methods
api.interceptors.request.use(
    (config) => {
        // Get the token
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        // If the token exists, add it to the headers
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
    }
);

// Add a response interceptor to error if the token cannot be obtained
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
    }
);

// Makes the call to the API through a proxy to get the active categories
export const getActiveCategories = async () => {
    try {
        const response = await api.get('/categories/active');
        return response;
    } catch (error) {
        throw error;
    }
}

// Makes the call to the API through a proxy to get the active sub categories
export const getActiveSubCategories = async () => {
    try {
        const response = await api.get('/subcategories/active');
        return response;
    } catch (error) {
        throw error;
    }
}

// Makes the call to the API through a proxy to get the active countries
export const getActiveCountries = async () => {
    try {
        const response = await api.get('/countries/active');
        return response;
    } catch (error) {
        throw error;
    }
}

// Makes the call to the API through a proxy to get the active states
export const getActiveStates = async () => {
    try {
        const response = await api.get('/states/active');
        return response;
    } catch (error) {
        throw error;
    }
}

// Makes the call to the API through a proxy to get the active contact types
export const getContactTypes = async () => {
    try {
        const response = await api.get('/contacttype/all');
        return response;
    } catch (error) {
        throw error;
    }
}

// Makes a call to the API through a proxy to get the active directory entries
export const getActiveDirectoryEntries = async () => {
    try {
        const response = await api.get('/directoryentry/active');
        return response;
    } catch (error) {
        throw error;
    }
}

// Makes a call to the API through a token to get the all directory entries if the a user is logged in
export const getAllDirectoryEntries = async () => {
    try {
        const response = await api.get('/directorylisting/all');
        return response;
    } catch (error) {
        throw error;
    }
}

// Makes a call to the API through a proxy to delete a pending directory listing based on the id
export const deletePendingDirectoryListing = async (id, listing) => {
    try {
        const options = {
            method: 'DELETE',
            url: `/pendinglisting/remove/${id}`,
            headers: {
            'Content-Type': 'application/json'
            },
            data: listing
        }
        const response = await api.request(options);
        return response;
    } catch (error) {
        throw error;
    }
}

// Makes a call to the API through a proxy to get the directory entry being updated based on the id
export const updateDirectoryEntry = async (id, form) => {
    try {
        const options = {
            method: 'PUT',
            url: `/directorylisting/update/${id}`,
            headers: {
            'Content-Type': 'application/json'
            },
            data: form
        }
        const response = await api.request(options);
        return response;
    } catch (error) {
        throw error;
    }
}

// Make a call to the API through a proxy to add a directory listing entry
export const addDirectoryEntry = async (listing) => {
    try {
        const options = {
            method: 'POST',
            url: `/directorylisting/create`,
            headers: {
            'Content-Type': 'application/json'
            },
            data: listing
        }
        const response = await api.request(options);
        return response;
    } catch (error) {
        throw error;
    }
}

//Makes a call to the API through a proxy to delete the directory entry base on the id provided
export const deleteDirectoryEntry = async (id) => {
    try{
        const response = await api.post('/directorylisting/remove/{id}', {
            id
        });
        return response.data;
    } catch (error){
        throw error;
    }
}

// Makes a call to the API through a proxy to get the active listing plans
export const getActiveListingPlans = async () => {
    try {
        const response = await api.get('/listingplan/active');
        return response;
    } catch (error) {
        throw error;
    }
}

// Makes the call to the API through a token to get the pending listings if the user is logged in
export const getPendingListings = async () => {
    try {
        const response = await api.get('/pendinglisting/all');
        return response;
    } catch (error) {
        throw error;
    }
}

// Makes the call to the API through a proxy to create a new pending listing
export const createPendingListing = async (newListing) => {
    try {
        const options = {
            method: 'POST',
            url: `/pendinglisting/create`,
            headers: {
            'Content-Type': 'application/json'
            },
            data: newListing
        }
        const response = await api.request(options);
        return response;
    } catch (error) {
        throw error;
    }
}

// Makes the call to the API through a proxy to delete a pending listing based on the id
export const deletePendingListing = async (id) => {
    try {
        const response = await api.post('/pendinglisting/remove/{id}', {
            id
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

// Makes the call to the API through a proxy to update a pending listing based on the id
export const updatePendingListing = async (id, newListing) => {
    try {
        const response = await api.put('/pendinglisting/update/{id}', {
                id,
            newListing
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

// Makes the call to the API through a proxy to create a contact email
export const createContactEmail = async (request) => {
    try {
        const options = {
            method: 'POST',
            url: `/sendEmail`,
            headers: {
            'Content-Type': 'application/json'
            },
            data: request
        }
        const response = await api.request(options);
        return response;
    } catch (error) {
        throw error;
    }
};
